import axios from 'axios';
import { removeToken, getToken } from './cookie';
import message from './message';
import { publicRoutes } from '@/utils/auth.jsx';
import i18n from './i18n';
let isRedirecting = false;
const service = axios.create({
  baseURL: '/',
  timeout: 300000, // request timeout
});

service.interceptors.request.use(
  (config) => {
    if (config.type === 'formdata') {
      config.headers['Content-Type'] = 'multipart/form-data';
    } else {
      config.headers['Content-Type'] = 'application/json';
    }
    if (config.method === 'get') {
      //  给data赋值以绕过if判断
      config.data = true;
    }

    if (getToken()) {
      config.headers['Authorization'] = 'Bearer ' + getToken();
    }
    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  },
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // console.log(location, res, '======errere');

    if (res.code === 0) {
      // 这里的操作是为了在编辑页内导出过程中除请求session以外的post请求返回code为0时刷新页面
      const session = response.config.url.indexOf('session');
      const previewUrl = response.config.url.indexOf('previewUrl');

      if (
        location.pathname === '/edit' &&
        response.config.method !== 'get' &&
        JSON.parse(sessionStorage.getItem('exportIngVuex')) &&
        session < 0 &&
        previewUrl < 0
      ) {
        location.reload();
      }
    }
    return res;
  },
  (error) => {
    console.log(error, 'error');
    if (error?.code === 'ERR_NETWORK') {
      message.error(i18n.t('As_Error_Network'), {
        id: 'only',
      });
      throw JSON.stringify(error.response.data);
    }

    if (error.response && error.response.status === 401) {
      removeToken();
      if (!['/login', ...publicRoutes].includes(window.location.pathname)) {
        if (!isRedirecting) {
          isRedirecting = true;
          localStorage.clear();
          window.location.href = '/login';
          isRedirecting = false; // 重定向完成后重置标志
        }
      }
      return;
    } else {
      // return error.response.data;
      // throw new Error('');

      if (error.response) {
        throw JSON.stringify(error.response.data);
      } else {
        if (error.config.url === '/api/upload/new-parts') {
          return;
        }
        // message.error(i18n.t('As_Error_Network'), {
        //   id: 'only',
        // });
        // return;
      }
    }
  },
);

export default service;
